module.exports = __webpack_public_path__ + "static/media/sex HarmActive.45cb0180.svg";